import { boolean, intersect, nullable, number, partial, string, struct } from 'io-ts/lib/Decoder';

import { Line } from '../../../ui/geometry/Line';
import { Path } from '../../../ui/geometry/Path';

/**
 * Represents a segment within a frame for HITL editing.
 *
 * Each segment is a geometry-based entity with its own:
 * - `id`: Unique identifier for the segment
 * - `height`: Height in mm
 * - `thickness`: Thickness in mm
 * - `correctedCenterLine`: Authoritative user-authored line.
 * - `points`: Polygon vertices for rendering (Path = Point[])
 *
 * This allows individual segments to be selected, removed, and
 * manipulated independently.
 */
export const Segment = intersect(
	struct({
		id: string,
		height: number,
		thickness: number,
		correctedCenterLine: Line,
		points: Path,
	})
)(
	partial({
		confidence: nullable(number),
		conflictGroupUuid: nullable(string),
		conflictGroupChooseOne: nullable(boolean),
	})
);
